module.exports = __webpack_public_path__ + "static/020.thumb-56040a36e0a3e5880561d3403b24b6be.jpg";